import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MainSlider from "../components/MainSlider";
import { supabase } from "../lib/supabaseClient.ts";
import BonPlansMobile from "./BonPlansMobile.js";
import BonPlansWeb from "./BonPlansWeb.js";

function BonPlans() {
  const [promoProducts, setPromoProducts] = useState([]);
const [isMobile, setIsMobile] = useState(false);
const parsePriceToNumber = (value) => {
  if (value == null) return 0;

  let cleanPrice = String(value)
    .replace(/[^\d.,-]/g, "")
    .trim();

  if (cleanPrice.includes(".") && cleanPrice.includes(",")) {
    cleanPrice = cleanPrice.replace(/\./g, "").replace(",", ".");
  } else if (cleanPrice.includes(",")) {
    const parts = cleanPrice.split(",");
    if (parts[1]?.length === 3) {
      cleanPrice = cleanPrice.replace(",", "");
    } else {
      cleanPrice = cleanPrice.replace(",", ".");
    }
  }

  return parseFloat(cleanPrice) || 0;
};

useEffect(() => {
  const checkMobile = () => setIsMobile(window.innerWidth <= 768);
  checkMobile();
  window.addEventListener("resize", checkMobile);
  return () => window.removeEventListener("resize", checkMobile);
}, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchPromoProducts();
  }, []);
const formatter = new Intl.NumberFormat('fr-FR', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});

  const fetchPromoProducts = async () => {
    try {
      // 1️⃣ Fetch products with promo = true
      const { data: products, error: productsError } = await supabase
        .from('products')
        .select('*')
        .eq('promo', true);

      if (productsError) throw productsError;

      // 2️⃣ Fetch all product_variations with promo = true
      const { data: variations, error: variationsError } = await supabase
        .from('product_variations')
        .select('*')
        .eq('promo', true);

      if (variationsError) throw variationsError;

      // 3️⃣ Group variations by product_id
      const variationsByProduct = {};
      variations.forEach(variation => {
        if (!variationsByProduct[variation.product_id]) {
          variationsByProduct[variation.product_id] = [];
        }
        variationsByProduct[variation.product_id].push(variation);
      });

      // 4️⃣ Fetch parent products for variations
      const variationProductIds = Object.keys(variationsByProduct).map(id => parseInt(id));
      const { data: variationProducts, error: varProductsError } = await supabase
        .from('products')
        .select('*')
        .in('id', variationProductIds);

      if (varProductsError) throw varProductsError;

      // 5️⃣ Combine results
      const allPromoProducts = [];

      // Add products with direct promo
products.forEach(product => {
  const basePrice = product.price ?? product.price_range ?? 0;

  const parsedPrice = parsePriceToNumber(basePrice);
  const promoPercent = product.promo_percentage || 0;
  const discountedPrice = parsedPrice * (1 - promoPercent / 100);

  allPromoProducts.push({
    ...product,
    type: "product",
    displayPrice: parsedPrice,         // NUMBER
    discountedPrice: discountedPrice  // NUMBER
  });
});




      // Add products with variation promos
 // Add all promo variations separately
variationProducts.forEach(product => {
  const promoVariations = variationsByProduct[product.id];
  if (!promoVariations || !promoVariations.length) return;

  promoVariations.forEach(variation => {
    const oldPrice = parsePriceToNumber(variation.old_price ?? variation.price);
    const newPrice = parsePriceToNumber(variation.price);

    allPromoProducts.push({
      ...product,
      type: "variation",
      variation: variation,
      displayPrice: oldPrice,
      discountedPrice: newPrice,
      promo_percentage: variation.promo_percentage,
      image: variation.image || product.image,
      variation_name: variation.variation_name,
      promo: true
    });
  });
});


      setPromoProducts(allPromoProducts);
    } catch (error) {
      console.error('Error fetching promo products:', error);
    }
  };

  return (
    <section className="slider-area">
      <MainSlider />

      {/* PROMOTIONS SECTION */}
      <div className="promo-banner-section py-5" style={{ background: "#f9f9f9" }}>
        <div className="section-title text-center mb-65">
          <div className="section-icon">
            <img src="img/icon/pawprint.png" alt="" />
          </div>
          <h5 className="sub-title">Promotions</h5>
          <h2 className="title">Profitez de nos offres exclusives</h2>
          <p
            className="section-title text-center"
            style={{
              maxWidth: "700px",
              margin: "0 auto",
              padding: "0 15px",
              lineHeight: "1.6",
              whiteSpace: "normal",
              textAlign: "center",
            }}
          >
            Chez <strong>Animalia+</strong>, nous vous proposons une sélection spéciale de produits en promotion, 
            alliant qualité et prix avantageux. Que ce soit pour gâter vos compagnons ou découvrir de nouvelles 
            références, nos promotions sont l'occasion idéale pour faire plaisir tout en faisant des économies. 
            Ne manquez pas ces offres limitées sur nos articles phares, du meilleur de l'alimentation aux 
            accessoires incontournables pour chiens et chats.
          </p>
        </div>

    {promoProducts.length > 0 ? (
  <div className="container">
    {isMobile ? (
      <BonPlansMobile promoProducts={promoProducts} />
    ) : (
      <BonPlansWeb promoProducts={promoProducts} />
    )}
  </div>
) : (
  <div className="col-12 text-center mt-4">
    <p className="fs-5">🐾 Aucun produit en promotion trouvé.</p>
  </div>
)}

      </div>
    </section>
  );
}

export default BonPlans;